module.exports = {"fields":{"seo":"Motd Name","name":"Community Name","url":"Community Url","paypal":"PayPal"}}


//////////////////
// WEBPACK FOOTER
// ./src/errors/community/validation.json
// module id = 286
// module chunks = 0